import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/icon-right-white.png'
import _imports_1 from '../../assets/images/dot-lines-1.png'
import _imports_2 from '../../assets/images/icon-right-red.png'


const _withScopeId = n => (_pushScopeId("data-v-3469f1f7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "capabilities-area pt-100 pb-75" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "d-sm-flex align-items-center justify-content-between mb-50 position-relative z-1" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "section-title left-title mb-0",
  "data-aos": "fade-up",
  "data-aos-duration": "1200",
  "data-aos-delay": "100"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "top-title" }, "CAPABILITIES"),
  /*#__PURE__*/_createElementVNode("h2", null, " Drive traffic, generate leads, achieve success with our paid search services! ")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "right-chevron"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "shape shape-1 position-absolute top-50 start-0 translate-middle-y",
  alt: "dot-lines-1",
  "data-aos": "fade-up",
  "data-aos-duration": "1200",
  "data-aos-delay": "300"
}, null, -1))
const _hoisted_7 = { class: "row justify-content-center" }
const _hoisted_8 = ["data-aos-delay"]
const _hoisted_9 = { class: "capabilities-single-item transition-y" }
const _hoisted_10 = { class: "icon" }
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "icon-right-red"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_router_link, {
          to: "/services",
          class: "default-btn mt-3 mt-sm-0",
          "data-aos": "fade-up",
          "data-aos-duration": "1200",
          "data-aos-delay": "200"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" VIEW ALL SERVICES "),
            _hoisted_5
          ]),
          _: 1
        }),
        _hoisted_6
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.capabilities, (capabilitie) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-xl-3 col-sm-6",
            key: capabilitie.id,
            "data-aos": "fade-up",
            "data-aos-duration": "1200",
            "data-aos-delay": capabilitie.dataDelay
          }, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("img", {
                  src: capabilitie.imageIcon,
                  alt: "Icon"
                }, null, 8, _hoisted_11)
              ]),
              _createElementVNode("h3", null, _toDisplayString(capabilitie.title), 1),
              _createElementVNode("p", null, _toDisplayString(capabilitie.description), 1),
              _createVNode(_component_router_link, {
                to: "/service-details",
                class: "read-more"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" READ MORE "),
                  _hoisted_12
                ]),
                _: 1
              })
            ])
          ], 8, _hoisted_8))
        }), 128))
      ])
    ])
  ]))
}